const normalize = (value) => String(value || '').trim();

const startsWithInsensitive = (value, prefix) => {
  const v = normalize(value).toLowerCase();
  const p = normalize(prefix).toLowerCase();
  if (!v || !p) return false;
  return v.startsWith(`${p} `) || v === p;
};

export const getDebtorDisplayName = (debtor) => {
  const name = normalize(debtor?.name);
  if (!name) return '';

  const type = debtor?.type;
  const legalForm = normalize(debtor?.legal_form);

  if (type === 'individual') return name;

  if (type === 'entrepreneur') {
    if (/^(ип|индивидуальный предприниматель)\b/i.test(name)) return name;
    return `ИП ${name}`;
  }

  if (type === 'legal' && legalForm && !startsWithInsensitive(name, legalForm)) {
    return `${legalForm} ${name}`;
  }

  return name;
};

export const getOrganizerDisplayName = (organizer) => {
  const name = normalize(organizer?.name);
  if (!name) return '';

  const entityType = organizer?.entity_type || (organizer?.type === 'arbitrage_manager' ? 'individual' : 'legal');
  const legalForm = normalize(organizer?.legal_form);

  if (entityType === 'individual') return name;

  if (entityType === 'entrepreneur') {
    if (/^(ип|индивидуальный предприниматель)\b/i.test(name)) return name;
    return `ИП ${name}`;
  }

  if (entityType === 'legal' && legalForm && !startsWithInsensitive(name, legalForm)) {
    return `${legalForm} ${name}`;
  }

  return name;
};
